import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/AudiusLogoHorizontal.svg'

export const IconAudiusLogoHorizontal = IconSVG as IconComponent
